import FRP from './views/frp.c';

export default FRP;
